import { render } from "./App.vue?vue&type=template&id=085b3dda"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=085b3dda&lang=css"

import exportComponent from "F:\\repos\\ideahonlapom\\gombavezetes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__